/**
 * Small things the Redirects page says about its requests (EST-134 follow-up, Oct 2026).
 */

/**
 * What a refused request said: the server's own words if it sent any, else the status.
 *
 * qrStats refuses in words ("Too many scans to count for this filter…", "Bad filter:
 * country", "Team members only"), and the page used to throw them away and show
 * "HTTP 422:". The status line of an HTTP/2 answer is usually empty, so that was all it said.
 *
 * @param {Response} response a fetch response that is not ok
 * @returns {Promise<string>}
 */
export async function refusalText(response) {
  try {
    const type = (response.headers && response.headers.get("content-type")) || "";
    if (type.includes("application/json")) {
      const body = await response.json();
      if (body && typeof body.error === "string" && body.error.trim()) return body.error.trim();
    }
  } catch (e) {
    // not JSON after all: the status will have to do
  }
  const status = `HTTP ${response.status}`;
  return response.statusText ? `${status}: ${response.statusText}` : status;
}

/**
 * Shown as a line under the filters while the UK filter is on (it was a hover on the filter's
 * button, which Lee could not find on 6 Oct 2026). With a country chosen, each campaign's
 * sources are
 * counted by the database from the source names it knows (functions/handlers/qr.js
 * countTypesForCountry). A scan under a name the campaign carries nowhere else is still
 * counted, but under "default": 3 scans of 59,599 for the UK when this was written.
 */
export const UK_FILTER_NOTE =
  "Redirects from the UK only. In this view a redirect whose source name the campaign does not otherwise carry is counted under \"default\". Each campaign's total is exact.";

/**
 * How many script requests (not people) the figures leave out: HubSpot's and Google Tag Manager's script files that
 * reached go as if they were links, recorded before go stopped recording them on 1 Nov 2026. Nothing for none, or for
 * a function from before that does not say.
 */
export function scriptHitsNote(n) {
  if (!Number.isFinite(n) || n <= 0) return null;
  return `${n.toLocaleString('en-GB')} script ${n === 1 ? 'request' : 'requests'} (not people: website scripts that reached go as if ${n === 1 ? 'it were a link' : 'they were links'}) recorded before 1 Nov 2026 ${n === 1 ? 'is' : 'are'} left out of these figures. go no longer records them. The figures by country cannot be split by type, so they still include them.`;
}
